document.addEventListener("DOMContentLoaded", () => {
    const allFaqConts = Array.from(document.querySelectorAll('.target-collapsable-faq'));

    allFaqConts.forEach((faq, index) => {
        if (faq.querySelector("a")) {
            const faqImgUrl = faq.querySelector("a").getAttribute("href");
            const faqImg = document.createElement("img");
            faqImg.src = faqImgUrl;
            faqImg.alt = "FAQ Image";
            faq.querySelector(".collapsable-content-section-body-inner.rte").appendChild(faqImg);

            faq.querySelector("a").style.display = "none";
        }
    })

})